<div class="p-0 d-flex flex-wrap flex-column justify-content-around align-items-center rounded">
  <!-- Not Owner Barcode Body -->
  <div class="w-100 barcode-content-container bg-primary text-white">
    <div class="barcode-content mx-3 pb-3">
      <div class="d-flex align-items-center barcode-details mb-4" *ngIf="card$ | async as card">
        <!--Name and ID-->
        <div class="barcode-name">
          <h5 class="mb-1 card-name" *ngIf="memberDetails$ | async as memberDetails">
            {{ 'home.nav.welcome' | translate }} {{ memberDetails.FirstName }}
          </h5>
          <div class="font-size-14">{{ card.ExternalRefNumber }} - {{ 'member.card.id' | translate }}</div>
        </div>
        <button class="btn d-flex btn-wallet" [routerLink]="'/rewards/wallet'">
          <div class="icon material-symbols-outlined me-1">qr_code_scanner</div>
          <div class="text-white">{{ 'barcode.wallet.button' | translate }}</div>
        </button>
      </div>
      <!--Balances-->
      <div class="user-balances">
        <!--Points Balance-->
        <div class="balance-widget" [ngClass]="{ 'kids-balance': isKid }">
          <div class="balance-details">
            <span class="icon material-icons">loyalty</span>
            <div class="balance">
              <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
              <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
            </div>
          </div>
        </div>
        <!--eCash Balance-->
        <ng-container *notInPopulation="[population.Kids]">
          <div class="balance-widget cursor-pointer" [routerLink]="'/hawksbucks'">
            <div class="balance-details">
              <span class="icon material-icons">loyalty</span>
              <div class="balance">
                <h5 class="mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</h5>
                <div class="font-size-12 me-1">{{ 'member.card.ecash.balance' | translate }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *notInPopulation="[population.Kids]">
        <fgb-ecash-button></fgb-ecash-button>
      </ng-container>

      <div class="navigation-row-container" #scrollContainer>
        <div class="navigation-row">
          <div class="nav-widget" [routerLink]="'/rewards/marketplace'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-icons">redeem</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.rewards' | translate }}
            </div>
          </div>

          <div class="nav-widget" [routerLink]="'/games'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-icons material-symbols-outlined">stadia_controller</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.games' | translate }}
            </div>
          </div>

          <div class="nav-widget" [routerLink]="'/challenges'">
            <div class="w-100 d-flex justify-content-center">
              <div class="nav-icon icon material-icons">emoji_events</div>
            </div>
            <div class="font-size-14">
              {{ 'nav.challenges' | translate }}
            </div>
          </div>

          <ng-container *inPopulation="[population.Kids]">
            <div class="nav-widget" [routerLink]="'/worksheets'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-icons">design_services</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.worksheets' | translate }}
              </div>
            </div>

            <div class="nav-widget" [routerLink]="'/earn'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-icons">money</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.earn' | translate }}
              </div>
            </div>
          </ng-container>

          <ng-container *notInPopulation="[population.Kids]">
            <a class="nav-widget text-white" [routerLink]="'/guardians'">
              <div class="w-100 d-flex justify-content-center">
                <div class="nav-icon icon material-icons">supervisor_account</div>
              </div>
              <div class="font-size-14">
                {{ 'nav.kids' | translate }}
              </div>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
